module.exports = __webpack_public_path__ + "static/media/logo.41b2f63b.svg";